module.exports = __webpack_public_path__ + "img/nyamoko4.69ec0655.jpg";